export const removeIndicatorSeparator = {
  IndicatorSeparator: () => null,
}

export const solidSelectStyles = {
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    backgroundColor: 'var(--bs-gray-100)',
    borderColor: state.isFocused ? 'var(--bs-primary)' : 'var(--bs-gray-100)',
    color: 'var(--bs-gray-700)',
    fontWeight: 500,
    minHeight: '41px',
    boxShadow: 'none',
    borderRadius: '0.475rem',
    paddingTop: '1px',
    paddingBottom: '1px',
    '&:hover': {
      borderColor: 'var(--bs-primary)',
    },
  }),
  valueContainer: (baseStyles: any) => ({
    ...baseStyles,
    minHeight: '39px',
    padding: '1px 12px',
  }),
  placeholder: (baseStyles: any) => ({
    ...baseStyles,
    color: 'var(--bs-gray-600)',
    fontWeight: 500,
    fontSize: '0.95rem',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (baseStyles: any) => ({
    ...baseStyles,
    color: 'var(--bs-gray-600)',
    padding: '0 10px 0 6px',
  }),
  menu: (baseStyles: any) => ({
    ...baseStyles,
    zIndex: 30,
    marginTop: '4px',
  }),
  menuList: (baseStyles: any) => ({
    ...baseStyles,
    paddingTop: '4px',
    paddingBottom: '4px',
  }),
  option: (baseStyles: any, state: any) => ({
    ...baseStyles,
    padding: '8px 12px',
    minHeight: 'unset',
    fontSize: '0.9rem',
    fontWeight: state.isSelected ? 600 : 500,
    backgroundColor: state.isSelected
      ? 'var(--bs-primary-light)'
      : state.isFocused
      ? 'var(--bs-gray-100)'
      : 'transparent',
    color: 'var(--bs-gray-800)',
    cursor: 'pointer',
  }),
  input: (baseStyles: any) => ({
    ...baseStyles,
    margin: 0,
    padding: 0,
  }),
  singleValue: (baseStyles: any) => ({
    ...baseStyles,
    color: 'var(--bs-gray-800)',
    fontWeight: 500,
    fontSize: '0.95rem',
  }),
  multiValue: () => ({
    display: 'none',
  }),
}
